(function () {
  'use strict';

  var STORAGE_KEY = 'sedrelle_wishlist';

  // NOTE ON PERSISTENCE / SCOPE:
  // This wishlist is stored entirely in the browser (localStorage, with a
  // cookie fallback below) — there is no server-side record. That means:
  //   - It does NOT sync across devices or browsers for the same customer.
  //   - It survives page reloads and normal browsing, but is lost if the
  //     shopper clears site data, uses a private/incognito window, or
  //     switches browsers.
  // Real cross-device sync would require storing the list against the
  // customer record (e.g. a customer metafield written via the Admin API,
  // typically through a small app or Shopify Function) rather than the
  // client alone. If that's ever added, `getWishlist`/`saveWishlist` below
  // are the only two functions that would need to change — everything else
  // in this file reads/writes through them.

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value) {
    var oneYear = 60 * 60 * 24 * 365;
    document.cookie = name + '=' + encodeURIComponent(value) + '; max-age=' + oneYear + '; path=/; SameSite=Lax';
  }

  // Wishlist items are keyed by product HANDLE (not id). The handle is what
  // lets the wishlist page fetch full product data client-side via the
  // public /products/{handle}.js endpoint, which requires no auth.
  //
  // Storage strategy: try localStorage first (larger capacity, easy to
  // read/write); if it's unavailable (disabled, private mode in some
  // browsers, quota errors) fall back to a cookie so the wishlist still
  // works rather than silently losing every "add" click.
  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (raw) return JSON.parse(raw);
    } catch (e) {
      // localStorage unavailable — fall through to cookie
    }
    try {
      var cookieRaw = getCookie(STORAGE_KEY);
      return cookieRaw ? JSON.parse(cookieRaw) : [];
    } catch (e2) {
      return [];
    }
  }

  function saveWishlist(handles) {
    var json = JSON.stringify(handles);
    var savedToLocalStorage = false;
    try {
      localStorage.setItem(STORAGE_KEY, json);
      savedToLocalStorage = true;
    } catch (e) {
      console.error('Could not save wishlist to localStorage, trying cookie fallback:', e);
    }
    // Cookies have a much smaller size limit than localStorage, so only use
    // the cookie as the primary store when localStorage genuinely failed.
    if (!savedToLocalStorage) {
      try {
        setCookie(STORAGE_KEY, json);
      } catch (e2) {
        console.error('Could not save wishlist:', e2);
      }
    }
  }

  function isWishlisted(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  function updateCountBadges() {
    var count = getWishlist().length;
    qsa('.wishlist-count').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function updateButtonStates() {
    var wishlist = getWishlist();
    qsa('.js-wishlist-toggle').forEach(function (btn) {
      var handle = btn.dataset.productHandle;
      btn.classList.toggle('is-active', wishlist.indexOf(handle) !== -1);
    });
  }

  function toggleProduct(handle) {
    var wishlist = getWishlist();
    var idx = wishlist.indexOf(handle);
    var added;
    if (idx === -1) {
      wishlist.push(handle);
      added = true;
    } else {
      wishlist.splice(idx, 1);
      added = false;
    }
    saveWishlist(wishlist);
    updateCountBadges();
    updateButtonStates();
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { handle: handle, added: added, wishlist: wishlist } }));
    return added;
  }

  function bindButtons() {
    qsa('.js-wishlist-toggle').forEach(function (btn) {
      if (btn.dataset.wishlistBound) return;
      btn.dataset.wishlistBound = 'true';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var handle = this.dataset.productHandle;
        if (!handle) return;
        toggleProduct(handle);
      });
    });
  }

  function init() {
    updateCountBadges();
    updateButtonStates();
    bindButtons();

    // Re-run when a collection's "Load more" button appends new product
    // cards, so wishlist buttons on the newly added cards also work.
    document.addEventListener('products:appended', function () {
      bindButtons();
      updateButtonStates();
    });
  }

  // Small public API so other scripts (e.g. the wishlist page renderer)
  // can read/modify the same localStorage-backed list without duplicating
  // this logic.
  window.SedrelleWishlist = {
    getWishlist: getWishlist,
    toggleProduct: toggleProduct,
    isWishlisted: isWishlisted,
    updateCountBadges: updateCountBadges,
    updateButtonStates: updateButtonStates,
    bindButtons: bindButtons
  };

  // wishlist-page.js (and anything else) may load/execute before this
  // script if it happens to appear earlier in the document. Dispatch an
  // event so those scripts don't have to rely on load order to know
  // window.SedrelleWishlist is ready.
  document.dispatchEvent(new CustomEvent('wishlist:ready'));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
